import React from "react";
import "./Inspire.css";

function Inspire(){
    return <p className="inspire">Inspiration:- <strong>Dereja.com</strong></p>;
}

export default Inspire;